export var KafkaSaslMechanism;
(function (KafkaSaslMechanism) {
    KafkaSaslMechanism["KAFKA_SASL_MECHANISM_PLAIN"] = "PLAIN";
    KafkaSaslMechanism["KAFKA_SASL_MECHANISM_SCRAM_SHA_256"] = "SCRAM-SHA-256";
    KafkaSaslMechanism["KAFKA_SASL_MECHANISM_SCRAM_SHA_512"] = "SCRAM-SHA-512";
    KafkaSaslMechanism["KAFKA_SASL_MECHANISM_OAUTHBEARER"] = "OAUTHBEARER";
    KafkaSaslMechanism["KAFKA_SASL_MECHANISM_GSSAPI"] = "GSSAPI";
})(KafkaSaslMechanism || (KafkaSaslMechanism = {}));
